<template>
  <div>
    <div class="app-container" v-if="isRouterAlive">
      <div class="container-page">
        <!-- 任务大盘 -->
        <div class="title-box">
          <span class="title">任务大盘</span>
          <svg-icon icon-class="flow" class="icon" @click="handleFlow" />
        </div>

        <!-- 操作按钮 -->
        <div class="operator-box">
          <el-row :gutter="32" type="flex" class="panel-group">
            <el-col :span="6" class="card-panel-col" v-for="(item, index) in panelList" :key="index">
              <div class="card-panel" :class="{
                  red: item.id == 1,
                  blue: item.id == 2,
                  purple: item.id == 3,
                  yellow: item.id == 4,
                  green: item.id == 5,
                  gray: item.id == -1,
                  active: currentId == item.id,
                }" @click="handlePanel(item.id)">
                <div class="card-panel-text">{{ item.name }}</div>
                <count-to :start-val="0" :end-val="item.total" :duration="2600 + index" class="card-panel-num" />
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 任务明细 -->
        <span class="title">任务明细</span>
        <!-- 筛选条件 -->
        <div class="filter-container filter-box">
          <div class="left-box">
            <!-- 外包商/需求标题模糊搜索 -->
            <el-input class="filter-item input_search" v-model="search" placeholder="外包商/发起人/需求标题模糊搜索" clearable @keyup.enter.native="handleFilter" @input="handleFilter" @clear="handleFilter" style="width: 300px">
              <svg-icon slot="prefix" class="el-input__icon icon" icon-class="search_shape" />
            </el-input>

            <!-- 项目名称 -->
            <el-select class="filter-item select-box" v-model="projectName" @change="handleFilter" filterable multiple clearable collapse-tags placeholder="项目名称" style="width: 180px">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <!-- 需求部门 -->
            <el-select class="filter-item select-box" v-model="department" @change="handleFilter" collapse-tags filterable multiple clearable placeholder="需求部门" style="width: 180px">
              <el-option v-for="item in departmentOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <!-- 外包商类型 -->
            <el-select class="filter-item" v-model="outsourcerType" @change="handleFilter" filterable clearable collapse-tags placeholder="外包商类型" style="width: 120px">
              <el-option v-for="item in outsourcerOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>

            <!-- 发起时间 -->
            <el-date-picker class="filter-item dateClass" v-model="time" @change="handleFilter" type="daterange" style="width: 280px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="发起时间"
              end-placeholder="" :range-separator="time && time[0]?'~':''" unlink-panels></el-date-picker>

          </div>

          <div class="right-box">
            <el-popover width="400" trigger="click">
              <el-button slot="reference" class="filter-item button_filter">
                <svg-icon icon-class="combined_shape" />
                <span class="button_span_style">筛选列</span>
              </el-button>

              <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                <el-checkbox v-for="(item, index) in tableTheadOptions" :key="index" :label="item" :disabled="index == 0">{{ item[Object.keys(item)[0]] }}</el-checkbox>
              </el-checkbox-group>
            </el-popover>

            <el-button class="filter-item button_add" type="primary" v-if="isCooper" @click="handleAdd">
              <i class="el-icon-plus" />
              <span class="button_span">发起新合作</span>
            </el-button>
          </div>
        </div>

        <!-- 表格 -->
        <el-table ref="table" class="grayTableTile_02" v-loading="tableloading" :data="tableList" :header-cell-style="{ 'background-color': '#f7f7f7', color: '#999' }" :row-class-name="handleRow"
          :show-overflow-tooltip="true" @sort-change="sortFun" height="634">
          >
          <el-table-column v-for="(item, index) of tableTheads" :key="Object.keys(item)[0]" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :fixed="index == 0 && tableList.length>0"
            :sortable="item['sortable']" show-overflow-tooltip :min-width="
              Object.keys(item)[0] == 'title' || Object.keys(item)[0] == 'completeTimeStr'
                ? 180
                : Object.keys(item)[0].indexOf('Time') > -1
                ? 120
                : Object.keys(item)[0] == 'comment'
                ? 150
                : 150
            ">
            <template slot-scope="scope">
              <!-- 需求标题 -->
              <div v-if="Object.keys(item)[0] == 'title'">
                <span @click="handleView(scope.row)" class="titleClass">{{
                  scope.row.title
                }}</span>
              </div>
              <!-- 发起时间 -->
              <div v-else-if="Object.keys(item)[0] == 'createTimeStr1'">
                <span>{{ scope.row.createTimeStr1.substring(0, 10) }}</span>
              </div>
              <!-- 任务状态 -->
              <div class="butn-style" :class="{
                  red: scope.row.status == 1,
                  blue: scope.row.status == 2,
                  purple: scope.row.status == 3,
                  yellow: scope.row.status == 4,
                  green: scope.row.status == 5,
                  gray: scope.row.status == -1,
                }" v-else-if="Object.keys(item)[0] == 'status'" @click="handleView(scope.row)">
                {{ scope.row.status | statusFilter }}
              </div>
              <!-- 外包商类型 -->
              <div v-else-if="Object.keys(item)[0] == 'outsourcerType'">
                <span v-if="scope.row.outsourcerType === 61">公司</span>
                <span v-if="scope.row.outsourcerType === 62">个人</span>
              </div>
              <!-- 实际完稿时间 -->
              <div v-else-if="Object.keys(item)[0] == 'completeTimeStr'">
                <span v-if="scope.row.completeTimeStr">{{
                  scope.row.completeTimeStr
                }}
                  <span v-if="scope.row.delayDayNum > 0" class="delayCellClass">延期{{
                  scope.row.delayDayNum
                }}天</span>
                </span>

                <span v-else>-</span>
              </div>
              <!-- 迭代版本 -->
              <div v-else-if="Object.keys(item)[0] == 'vnums'">
                <span class="vnumsClass" style="color: #3a89ff; cursor: pointer" @click="handleVersions(scope.row)" v-if="scope.row.status == 4 || scope.row.status == 5">{{ scope.row.vnums }}</span>
                <span v-else>-</span>
              </div>
              <!-- 评价 -->
              <div v-else-if="Object.keys(item)[0] == 'comment'">
                <div v-if="scope.row.status == 4 || scope.row.status == 5">
                  <el-popover popper-class="score-popper" placement="top-start" :title="'综合评分：' + scope.row.comment + '分'" width="400" trigger="hover" v-if="scope.row.comment">
                    <div class="comment-box">
                      <div class="comment-item" v-for="(item, index) in scope.row.evaluateList" :key="index">
                        <span class="label">{{ item.name }}</span>
                        <el-rate v-model="item.score" disabled disabled-void-color="#CCCCC"></el-rate>
                      </div>
                    </div>
                    <el-rate slot="reference" v-model="scope.row.comment" disabled disabled-void-color="#CCCCC"></el-rate>
                  </el-popover>
                  <!-- <span class="link" v-else>评价</span> -->
                  <span class="empty" v-else>-</span>
                </div>
                <div class="empty" v-else>-</div>
              </div>
              <!-- 正常展示 -->
              <span v-else>{{ scope.row[Object.keys(item)[0]] }}</span>
            </template>
          </el-table-column>

          <el-table-column :fixed="tableList.length>0?'right':false" label="操作" width="200" align="right" header-align="right">
            <template slot-scope="scope">
              <template v-if="
                  (scope.row.status == 1 ||
                    scope.row.status == 2 ||
                    scope.row.status == -1) &&
                  scope.row.createUserId === $store.state.user.userId
                ">
                <el-button type="text" @click="handleRepeal(scope.row)">撤销</el-button>
                <div class="line"></div>
                <el-button type="text" @click="handleDemandChange(scope.row)">需求变更</el-button>
                <div class="line"></div>
              </template>
              <el-button type="text" @click="handleView(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination class="pagination" style="padding-bottom:0px" v-show="total > 0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" />
      </div>

      <!-- 大图 图例 -->
      <flow-dialog ref="flow"></flow-dialog>

      <!-- 迭代版本 -->
      <interation ref="version"></interation>

      <!-- 右侧抽屉 详情 -->
      <transfer-drawer ref="drawer"></transfer-drawer>
    </div>
  </div>
</template>

<script>
import CountTo from "vue-count-to";
import Pagination from "@/components/Pagination";
import FlowDialog from "./components/flowDialog";
import Interation from "./components/interation.vue";
import TransferDrawer from "./components/transferDrawer";
import {
  outsource_flowStatusNum,
  outsource_flowList,
  config_departmentList,
  outsource_flowModifyStatus,
} from "@File~/api/outsourcing";
import { projectList_ajax } from "@File~/api/file";
import { arrSlice, sortKeys } from "@/filters";

const defaultFormThead = [
  { title: "需求标题" },
  { projectName: "项目", sortable: "custom" },
  { designTypeName: "设计分类", sortable: "custom" },
  { createUserName: "发起人", sortable: "custom" },
  { departmentName: "需求部门", sortable: "custom" },
  { createTimeStr1: "发起时间", sortable: "custom" },
  { status: "任务状态", sortable: "custom" },
  { outsourcerName: "合作外包商" },
  { outsourcerType: "外包商类型" },
  { planTimeEndStr: "预计完稿时间" },
  { completeTimeStr: "实际完稿时间" },
  { vnums: "迭代版本" },
  { comment: "供应商综合评价", sortable: "custom" },
];

export default {
  components: { CountTo, Pagination, FlowDialog, Interation, TransferDrawer },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //子组件修改内容状态后刷新当前页面使用
      isCooper: false,
      panelList: [
        {
          id: 1,
          name: "全部待审批",
          total: 0,
        },
        {
          id: 2,
          name: "全部进行中",
          total: 0,
        },
        {
          id: 3,
          name: "全部待验收",
          total: 0,
        },
        {
          id: 4,
          name: "全部待结算",
          total: 0,
        },
        {
          id: 5,
          name: "全部已完成",
          total: 0,
        },
        {
          id: -1,
          name: "全部已拒绝",
          total: 0,
        },
      ],

      currentId: null, // 当前面版

      search: "",
      projectName: [], // 项目名称
      sponsor: "", // 发起人
      department: [], // 需求部门
      outsourcerType: "", //外包商
      time: [], // 发起时间
      sortColumn: "createTimeStr1",
      sortType: "DESC",

      projectOptions: [], // 项目列表
      sponsorOptions: [], // 发起人列表
      departmentOptions: [], // 需求部门列表
      outsourcerOptions: [
        { name: "公司", id: 61 },
        { name: "个人", id: 62 },
      ],

      tableTheadOptions: defaultFormThead, // 筛选列
      checkboxTitle: defaultFormThead, // 默认选中

      // 表格
      tableloading: false,
      tableTheads: defaultFormThead,
      originalCaseTable: [], // 原始数据
      caseTable: [], // 排序后数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10,
      },

      // 评价 临时
      evaluateList: [
        {
          name: "质量",
          score: 3,
        },
        {
          name: "服务",
          score: 3,
        },
        {
          name: "守时",
          score: 3,
        },
        {
          name: "经验",
          score: 3,
        },
        {
          name: "性价比",
          score: 3,
        },
      ],
    };
  },

  filters: {
    // 状态
    statusFilter(status) {
      // const statusMap = {
      //   1: "待审批",
      //   2: "进行中",
      //   3: "待验收",
      //   4: "待结算",
      //   5: "已完成",
      //   -1: "已拒绝"
      // };
      let statuStr = "";
      switch (status) {
        case 1:
          statuStr = "待审批";
          break;
        case 2:
          statuStr = "进行中";
          break;
        case 3:
          statuStr = "待验收";
          break;
        case 4:
          statuStr = "待结算";
          break;
        case 5:
          statuStr = "已完成";
          break;
        case -1:
          statuStr = "已拒绝";
          break;
      }
      // return statusMap[status];
      return statuStr;
    },
  },
  computed: {
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable;
      if (caseTable.length > 0) {
        this.total = caseTable.length;
        // 将一维数组切割成二维数组
        this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize);
        this.tableData = this.handCaseTable[this.listQuery.pageNo - 1];
      } else {
        this.tableData = []
      }
      return this.tableData;
    },
  },

  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(
        (i) => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1
      );
      console.log("=======", this.tableTheads);
      // this.getList();
      // this.$refs.table.doLayout()
    },
  },
  created() {
    llnloop: for (let item of this.$store.getters.permission_routes) {
      if (item.children && item.children.length > 0) {
        for (let ele of item.children) {
          if (ele.path === "newOutsourceFlow") {
            this.isCooper = true;
            break llnloop;
          }
        }
      }
    }
    this.getLine();
    this.getList();
    this.getProjectFun();
    this.getDepartmentFun();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.getLine();
        this.getList();
        this.isRouterAlive = true;
      });
    },

    // 获取任务大盘数据
    getLine() {
      this.panelList = [
        {
          id: 1,
          name: "全部待审批",
          total: 0,
        },
        {
          id: 2,
          name: "全部进行中",
          total: 0,
        },
        {
          id: 3,
          name: "全部待验收",
          total: 0,
        },
        {
          id: 4,
          name: "全部待结算",
          total: 0,
        },
        {
          id: 5,
          name: "全部已完成",
          total: 0,
        },
        {
          id: -1,
          name: "全部已拒绝",
          total: 0,
        },
      ];
      outsource_flowStatusNum().then((response) => {
        if (response.code == 1) {
          response.data.map((item) => {
            for (let element of this.panelList) {
              if (item.status === element.id) {
                element.total = item.num;
              }
            }
          });
        }
      });
    },
    // 获取列表
    getList() {

      let data = {
        // ...this.listQuery,
        // pageNo:1,
        // pageSize:10,
        // orderByTypeStr: this.sortColumn+' '+this.sortType,
        keyword: this.search,
        createTimeStr: this.time && this.time.length > 0 ? this.time.join(' - ') : '',
        projectIds: this.projectName,
        createUserIds: [],
        departmentIds: this.department,
        outsourcerType: this.outsourcerType ? [this.outsourcerType] : [],
        roleIds: this.$store.getters.roles,
        status: this.currentId,
      };
      var tempTime1 = new Date().getTime();
      this.tableloading = true;
      outsource_flowList(data).then((response) => {
        if (response.code == 1) {
          console.log(new Date().getTime() - tempTime1);
          this.total = response.data.length;
          // this.tableList = response.data.result;
          response.data.map((item, index) => {
            if ((item.status === 4 || item.status === 5) && item.comment) {
              let tempComment = JSON.parse(item.comment);
              item.evaluateList = [];
              let tempResultScore = 0;
              for (let key in tempComment) {
                item.evaluateList.push({ name: key, score: tempComment[key] });
                tempResultScore += tempComment[key];
              }
              item.comment = tempResultScore / 5;
            }
          });

          this.caseTable = response.data;
          this.originalCaseTable = JSON.parse(JSON.stringify(response.data));
          this.tableloading = false;
        }
      });
    },
    //部门列表
    getDepartmentFun() {
      config_departmentList().then((response) => {
        if (response.code == 1) {
          this.departmentOptions = response.data;
        }
      });
    },

    // 项目列表
    getProjectFun() {
      projectList_ajax().then((response) => {
        if (response.code == 1) {
          this.projectOptions = response.data;
        }
      });
    },

    sortFun(e) {
      // console.log(this.caseTable)

      // if (e.order) {
      //     this.sortColumn = e.prop
      //     this.sortType = e.order == 'ascending' ? 'ASC' : 'DESC'
      // } else {
      //   //默认
      //   this.sortColumn = 'createTimeStr'
      //   this.sortType = 'DESC'
      // }
      if (e.order) {
        const order = e.order == "descending" ? false : true;
        this.caseTable.sort(sortKeys(e.prop, order));
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable));
      }

      // this.listQuery.pageNo = 1
      // this.getList()
    },

    // 查询
    handleFilter() {
      this.listQuery.pageNo = 1;
      this.getList();
    },

    // 操作面板
    handlePanel(id) {
      this.currentId = id;
      this.getLine();
      this.getList();
    },

    // 发起新合作
    handleAdd() {
      // this.$router.push(cooperation)
      this.$router.push({ path: "/outsourceTaskCenter/newOutsourceFlow" });
    },

    // 撤销
    handleRepeal(row) {
      this.$confirm("确定要撤销该任务吗？", "撤销任务", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "button-primary-plain",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: row.id,
            userId: this.$store.state.user.userId,
            status: -2,
            // statusStr:'撤销',
            // comment:'',
            noticeType: 0,
          };
          outsource_flowModifyStatus(data).then((response) => {
            if (response.code == 1) {
              this.getList();
              this.$message({ type: "success", message: "撤销成功" });
            }
          });
        })
        .catch(() => { });
    },

    // 需求变更
    handleDemandChange(row) {
      this.$confirm("是否确定进行需求变更？", "需求变更", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "button-primary-plain",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/outsourceTaskCenter/newOutsourceFlow",
            query: { flowId: window.btoa(row.id) },
          });
        })
        .catch(() => { });
    },

    // 查看详情
    handleView(row) {
      this.$refs["drawer"].init(row);
    },

    // 展示流程图
    handleFlow() {
      this.$refs.flow.flowDialog = true;
    },

    // 迭代版本
    handleVersions(row) {
      this.$refs["version"].init(row);
    },

    // 设置表格 行class
    handleRow({ row }) {
      // console.log('行====',row)
      let rowName = "";
      switch (row.status) {
        case 1:
          rowName = "red";
          break;
        case 2:
          rowName = "blue";
          break;
        case 3:
          rowName = "purple";
          break;
        case 4:
          rowName = "yellow";
          break;
        case 5:
          rowName = "green";
          break;
        case -1:
          rowName = "gray";
          break;
        default:
          rowName = "";
      }
      return rowName;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px 32px 61px;
  min-height: calc(100vh - 50px);
  overflow: hidden;
  background: #f5f5f5;
}
.container-page {
  // height: calc(100vh - 71px);
  padding: 24px 24px;
  background: #ffffff;
  border-radius: 4px;
  position: relative;
}
.title-box {
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 23px;
  .title {
    line-height: 22px;
    font-size: 16px;
    color: #333333;
  }
  .icon {
    font-size: 16px;
    margin-left: 8px;
    cursor: pointer;
  }
}
.operator-box {
  margin-bottom: 31px;
  padding-bottom: 32px;
  border-bottom: 1px solid #eeeeee;

  .card-panel {
    padding: 16px 20px;
    border-radius: 4px;
    cursor: pointer;
    .card-panel-text {
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 4px;
    }
    .card-panel-num {
      font-size: 24px;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
    }
    &.active {
      box-shadow: 0px 4px 10px 4px rgba(0, 0, 0, 0.07),
        0px 3px 5px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -2px rgba(0, 0, 0, 0.12);
    }
  }
  .red {
    background: #ffe9eb;
  }
  .blue {
    background: #e3f1fb;
  }
  .purple {
    background: #f2ecfe;
  }
  .yellow {
    background: #fff1e6;
  }
  .green {
    background: #dbf8ec;
  }
  .gray {
    background: #eeeeee;
  }
}
.filter-box {
  margin: 20px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
  .button_span {
    margin-left: 4px;
  }

  ::v-deep .el-input__inner {
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    color: #333;
  }

  // ::v-deep .el-icon-arrow-up:before {
  //   content: "\E78F";
  //   color: #666;
  // }
}
.right-box {
  flex-shrink: 0;
  width: 240px;
  text-align: right;
}
// input search
.input_search {
  ::v-deep .el-input__inner {
    padding-left: 44px;
  }
  ::v-deep .el-input__prefix {
    width: 20px;
    height: 20px;
    margin: 8px 12px 8px 12px;
    .icon {
      width: 20px;
      height: 20px;
    }
  }
}
// 新增按钮
.button_add {
  padding: 10px 16px;
  margin-left: 16px;
}
.button_filter {
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 10px 12px;
}
// 表格
.grayTableTile_02 {
  .line {
    display: inline-block;
    width: 2px;
    height: 16px;
    background: #ccc;
    vertical-align: middle;
    margin: 0 3px;
  }

  ::v-deep .el-table__fixed {
    height: 623px !important;
  }
  ::v-deep .el-table__fixed-right {
    height: 623px !important;
  }

  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
  }
  // 滚动条的滑块
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 5px;
  }

  ::v-deep .red td:first-child {
    border-left: 4px solid #fb6c75;
  }
  ::v-deep .blue td:first-child {
    border-left: 4px solid#439DE2;
  }
  ::v-deep .purple td:first-child {
    border-left: 4px solid #876fff;
  }
  ::v-deep .yellow td:first-child {
    border-left: 4px solid #ffa356;
  }
  ::v-deep .green td:first-child {
    border-left: 4px solid #0ed27f;
  }
  ::v-deep .gray td:first-child {
    border-left: 4px solid#CCCCCC;
  }
  .titleClass {
    width: 160px;
    color: #3a89ff;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      text-decoration: underline;
    }
  }
  .delayCellClass {
    display: inline-block;
    height: 16px;
    background-color: #e22b4b;
    color: #fff;
    font-size: 12px;
    line-height: 12px;
    border-radius: 8px;
    padding: 2px 5px;
  }
  .vnumsClass {
    color: #3a89ff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .butn-style {
    display: block;
    max-width: 120px;
    width: 100%;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
  .butn-style.red {
    background: #ffe9eb;
  }
  .butn-style.blue {
    background: #e3f1fb;
  }
  .butn-style.purple {
    background: #f2ecfe;
  }
  .butn-style.yellow {
    background: #fff1e6;
  }
  .butn-style.green {
    background: #dbf8ec;
  }
  .butn-style.gray {
    background: #eeeeee;
  }
  .empty {
    color: #333333;
  }
}

// 评分
// ::v-deep .score-popper{
//     padding: 16px 16px 8px;
//     ::v-deep .el-popover__title{
//         font-size: 14px;
//         font-weight: 500;
//         color: #333333;
//         line-height: 20px;
//         margin-bottom: 8px;
//     }
// }
.comment-box {
  display: flex;
  flex-flow: row wrap;
  .comment-item {
    width: 50%;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 6px;
  }
  .label {
    min-width: 36px;
    font-size: 12px;
    color: #666666;
    margin-right: 8px;
    line-height: 18px;
  }
}
::v-deep .el-rate__icon {
  margin-right: 0;
  font-size: 20px;
}

// 表格固定 滚动
// .grayTableTile_02 ::v-deep .el-table__body-wrapper {
//     z-index: 1;
// }

// table 定位有条线
::v-deep .el-table__fixed-right:before,
::v-deep .el-table__fixed:before {
  background-color: transparent;
}

.select-box {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 60%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
  ::v-deep .el-select-dropdown__item {
    padding: 0 20px 0 10px;
  }
  ::v-deep .el-select-dropdown__item.selected::after {
    right: 5px;
  }
}

.dateClass {
  ::v-deep .el-icon-date:before {
    content: url("../../assets/date.png");
    position: absolute;
    top: 6px;
    left: 10px;
  }
}
</style>